import React, {useContext, useEffect, useRef, useState} from 'react';
import {useMapEvents} from 'react-leaflet';
import { Context } from '../store/reducer';
import L from "leaflet";
import happen from "happen"

import m_pin_blue from '../assets/img/marker/m_pin_blue.png';

/**
 * 法規制用のマップクリックを制御するコンポーネント
 * 複数のタイルレイヤーのクリックを検知するために以下の方法を使用している。
 * 1. マップでクリックを検知。
 * 2. ClickされたDOM要素の画面位置情報(緯度経度ではない)を取得し、happenを使用して一番上に表示されているtileのクリックイベントを発火
 * 3. 一番上のタイルを非表示にする(=メニューのチェックを外す)
 * 4. 表示中の全てのレイヤで繰り返し、表示を元に戻す。
 * @returns {JSX.Element}
 * @constructor
 */
const Component = () => {
    const { dispatch } = useContext(Context);
    const { state } = useContext(Context);
    const renderFlgRef = useRef(false) //初回マウント時のuseEffect内の処理を飛ばすため
    
    let icon = m_pin_blue
    
    const iconUrl = new L.Icon({
        iconUrl: icon,
        iconRetinaUrl: icon,
        iconSize: [35, 35],
        iconAnchor: [17, 23],
        popupAnchor: [0, -50]
    });
    
    useEffect(()=>{
        if(renderFlgRef.current){ 
            state.clickedTileFeatureInfo.id.map(id=>{
                dispatch({
                    type: 'TOGGLE_CHECKED',
                    category: id
                })
            })
            
            // マーカーを1つのみ表示するためにtitleを元に削除する。
            map.eachLayer(function (layer) {
                if (layer && layer.options.title === 'lawMarker') {
                    layer.remove();
                }
            });

            let popup = "";
            
            popup += "<dl className='dl-list is-modal-spot'>"

            const datasetSet = new Set();
            const datasetList = [];
            
            state.clickedTileFeatureInfo.id.map(id => {

                // 森林法はレイヤー4つに対し、データセットは1つなのキーとなるidを変換する。
                let key = ["vis_90_5_1","vis_90_5_2","vis_90_5_3","vis_90_5_4"].includes(id) 
                  ? "vis_90_5"
                  : id;
                
                // 河川法も森林法と同様に3つのサブレイヤーが同じものを指す。
                if (["vis_90_9_1","vis_90_9_2","vis_90_9_3"].includes(id)) {
                    key = "vis_90_9"
                } else if (["vis_90_11_1"].includes(id)) {
                    // 文化財保護法はvis_90_11_1がvis_90_11のデータセットを意味する。
                    key = "vis_90_11"
                }
                
                const dataset = state.data_for_90.data[key]

                // 同じデータセットを指す場合は重複禁止にして1つに絞る。
                if ( ! datasetSet.has(key)) {
                    datasetList.push(dataset)
                    datasetSet.add(key);
                }
            })
            
            datasetList.map(dataset => {
              if (dataset) {
                popup += `<dd><a href="${dataset.url}" target={"_blank"}>・${dataset.dataset_name} </a></dd>`;
              }  
            })
            
            
            popup += "</dl>"

            popup += "<p>法令名をクリックすると，規制の内容や手続き方法の確認画面に移動します。</p>";
            
            if(state.clickedTileFeatureInfo.id.length > 0){
                
                const markerOptions = {
                    icon:iconUrl,
                    title: "lawMarker"
                }

                L.marker(state.clickedPointLatLng, markerOptions)
                    .bindPopup(popup)
                    .addTo(map)
                    .openPopup()
            }
            

            dispatch({
                type: 'CLEAR_VLAYER_INFO',
                id: [],
                properties: []
            })
        } else {
            renderFlgRef.current = true
        }
           
    }, [state.clickedPointLatLng])
    
    const map = useMapEvents({
        click(e) {

            if(e.originalEvent.isTrusted){
                
                let layerNum = -1
                map.eachLayer(()=>layerNum++)

                for (let index = 0; index < layerNum; index++) {

                    // ClickされたDOM要素の画面位置情報(緯度経度ではない)を取得
                    const elm = document.elementFromPoint(e.containerPoint.x, e.containerPoint.y);

                    // happenを使用してクリックイベントを発火(leafletの仕様上、一番上に表示されているtileのイベントのみが発火する)
                    happen.once(elm, {type: 'click', clientX: e.containerPoint.x, clientY: e.containerPoint.y})
                }
                
                dispatch({type:'SET_VLAYER_LATLNG', latlng:e.latlng})    
            }
        },
    })

    return (<></>);
}

export default Component
